<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Referensi Tingkatan</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Referensi Tingkatan</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tabtingkatan" data-toggle="tab">Tingkatan</a>
                                            </li>
											<li class="nav-item">
												<a class="nav-link" href="#tabkategori" data-toggle="tab">Kategori</a>                                                
											</li>                                              
											<li class="nav-item">
												<a class="nav-link" href="#tabsubject" data-toggle="tab"><span class="med-records">Subject</span></a>
											</li> 
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Tingkatan Tab -->
										<div id="tabtingkatan" class="tab-pane fade show active">
											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdl">Tambah Data</a>
                                                    </div>
                                                    <!-- <datatable :columns="columns" :data="reftingkatan"></datatable> -->

													<div class="table-responsive">
                                                        <table id="tbl" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Nama Tingkatan</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in reftingkatan" :key="ref.id_tingkatan">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_tingkatan }}</td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEdit(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDelete(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
										<!-- /Class Records Tab -->
                                        
                                        <!-- Kategori Tab -->
										<div id="tabkategori" class="tab-pane fade show">
											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdlMateri">Tambah Materi</a>
                                                    </div>
													<div class="table-responsive">
                                                        <table id="tblMateri" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Tingkatan</th>
                                                                    <th class="text-left">Materi</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstmateri" :key="ref.id_materi">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_tingkatan }}</td>
                                                                    <td>{{ ref.nama_materi }}</td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEditMateri(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDeleteMateri(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Kategori Tab -->
										
										<!-- Subject Tab -->
										<div id="tabsubject" class="tab-pane fade show ">
											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdlSub">Tambah Data</a>
                                                    </div>
													<div class="table-responsive">
                                                        <table id="tblSub" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Materi</th>
                                                                    <th class="text-left">Sub Materi</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstsubmateri" :key="ref.id_sub_materi">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_tingkatan }} - {{ ref.nama_materi }}</td>
                                                                    <td>{{ ref.nama_sub_materi }}</td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEditSub(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDeleteSub(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Subject Tab -->
										
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <div id="addMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Referensi Tingkatan</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Nama Tingkatan <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="tingkatan.nama_tingkatan">
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="save">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Referensi Tingkatan</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus referensi tingkatan <b>{{ tingkatan.nama_tingkatan }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- ---------- -->
        <div id="addMdlMateri" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Pilih Tingkatan <span class="text-danger">*</span></label>
                                <v-select
                                :options="reftingkatan"
                                :reduce="reftingkatan => reftingkatan.id_tingkatan" 
                                label="nama_tingkatan"
                                v-model="materi.id_tingkatan"
                                />                              
                            </div>
                            <div class="form-group">
                                <label>Nama Materi <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="materi.nama_materi">
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="saveMateri">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="delMdlMateri" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus materi <b>{{ materi.nama_materi }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapusMateri">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- ---------- -->
        <div id="addMdlSub" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Sub Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Pilih Materi <span class="text-danger">*</span></label>
                                <v-select
                                :options="lstmateri"
                                :reduce="lstmateri => lstmateri.id_materi" 
                                label="optmateri"
                                v-model="submateri.id_materi"
                                />                              
                            </div>
                            <div class="form-group">
                                <label>Nama Sub Materi <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="submateri.nama_sub_materi">
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="saveSub">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div id="delMdlSub" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Sub Materi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus Sub Materi <b>{{ submateri.nama_sub_materi }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapusSub">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'Instansi',
    // vuetify: new Vuetify(),
    data() {
        return {
            reftingkatan: [],
            tingkatan:{
                id_tingkatan: '',
                nama_tingkatan: ''
            },
            lstmateri: [],
            materi:{
                id_materi: '',
                id_tingkatan: '',
                nama_materi: '',
            },
            lstsubmateri: [],
            submateri: {
                id_sub_materi: '',
                id_materi: '',
                nama_sub_materi: '',
            },
        }
    },
    created: function () {
        // this.refreshAll();
        
        this.getAll();
        this.getAllMateri();
        this.getAllSub();
        // this.initDt("tblMateri");
        // this.initDt("tblSub");

    },  

    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,
                });
               }, 300)
               
                
        },
      
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        reloadTbl(tbId){

            // dT.destroy();
            $('#'+tbId).DataTable();
            $('#'+tbId).destroy();
            this.initDt('#'+tbId);
            // $('#'+tbId).ajax.reload();
        },

        refreshAll(){
            this.getAll();
            this.getAllMateri();
            this.getAllSub();
            
            // this.reloadTbl("tbl");
            // this.reloadTbl("tblMateri");
            // this.reloadTbl("tblSub");
        },

        // Get Product
        getAll: function () {
            axios.get('api/reftingkatan')
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tbl");
                    this.reftingkatan = res.data.data;
                    this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New product
        save: function () {
            axios.post('api/reftingkatan', {
                    id_tingkatan: this.tingkatan.id_tingkatan,
                    nama_tingkatan: this.tingkatan.nama_tingkatan
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#addMdl").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        resetVar: function(ref){
            if(ref){
                this.tingkatan.id_tingkatan = ref.id_tingkatan;
                this.tingkatan.nama_tingkatan = ref.nama_tingkatan;
            } else {
                this.tingkatan.id_tingkatan = '';
                this.tingkatan.nama_tingkatan = '';
            }
        },

        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            this.resetVar(ref);
            $("#addMdl").modal('show');
        },
 
        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },
 
        // Delete Product
        hapus: function () {
            axios.post('api/reftingkatandel', {
                    id_tingkatan: this.tingkatan.id_tingkatan,
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#delMdl").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        //--------------------------
        // Get Materi
        getAllMateri: function () {
            axios.get('api/materi')
                .then(res => {
                    // console.log(res.data);
                    
                    this.clearTbl("tblMateri");
                    this.lstmateri = res.data.data;
                    this.initDt("tblMateri");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New Materi
        saveMateri: function () {
            axios.post('api/materi', {
                    id_materi: this.materi.id_materi,
                    id_tingkatan: this.materi.id_tingkatan,
                    nama_materi: this.materi.nama_materi
                })
                .then(res => {
                    // handle success
                    this.getAllMateri();
                    this.resetVarMateri();
                    $("#addMdlMateri").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        resetVarMateri: function(ref){
            if(ref){
                this.materi.id_materi = ref.id_materi;
                this.materi.id_tingkatan = ref.id_tingkatan;
                this.materi.nama_materi = ref.nama_materi;
            } else {
                this.materi.id_materi = '';
                this.materi.id_tingkatan = '';
                this.materi.nama_materi = '';
            }
        },

        // Get Edit and Show data to Modal
        getEditMateri: function (ref) {
            this.resetVarMateri(ref);
            $("#addMdlMateri").modal('show');
        },
 
        // Get Delete and Show Confirm Modal
        getDeleteMateri: function (ref) {
            this.resetVarMateri(ref);
            $("#delMdlMateri").modal('show');
        },
 
        // Delete Materi
        hapusMateri: function () {
            axios.post('api/materidel', {
                    id_materi: this.materi.id_materi
                })
                .then(res => {
                    // handle success
                    this.getAllMateri();
                    this.resetVarMateri();
                    $("#delMdlMateri").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        //--------------------------
        // Get sub_materi
        getAllSub: function () {
            axios.get('api/submateri')
                .then(res => {
                    // console.log(res.data);  
                    this.clearTbl("tblSub");
                    this.lstsubmateri = res.data.data;
                    this.lstsubject = this.lstsubmateri;
                    this.initDt("tblSub");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New sub_materi
        saveSub: function () {
            axios.post('api/submateri', {
                    id_sub_materi: this.submateri.id_sub_materi,
                    id_materi: this.submateri.id_materi,
                    nama_sub_materi: this.submateri.nama_sub_materi
                })
                .then(res => {
                    // handle success
                    this.getAllSub();
                    this.resetVarSub();
                    $("#addMdlSub").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        resetVarSub: function(ref){
            if(ref){
                this.submateri.id_sub_materi = ref.id_sub_materi;
                this.submateri.id_materi = ref.id_materi;
                this.submateri.nama_sub_materi = ref.nama_sub_materi;
            } else {
                this.submateri.id_sub_materi = '';
                this.submateri.id_materi = '';
                this.submateri.nama_sub_materi = '';
            }
        },

        // Get Edit and Show data to Modal
        getEditSub: function (ref) {
            this.resetVarSub(ref);
            $("#addMdlSub").modal('show');
        },
 
        // Get Delete and Show Confirm Modal
        getDeleteSub: function (ref) {
            this.resetVarSub(ref);
            $("#delMdlSub").modal('show');
        },
 
        // Delete sub_materi
        hapusSub: function () {
            axios.post('api/submateridel', {
                    id_sub_materi: this.submateri.id_sub_materi
                })
                .then(res => {
                    // handle success
                    this.getAllSub();
                    this.resetVarSub();
                    $("#delMdlSub").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/RefTingkatan/index.vue